import styles from './styles.module.scss';

export default function ToolbarButton(props) {
  const { className, children, ...rest } = props;

  return (
    <button
      type="button"
      className={`${styles.button} ${className ?? ''}`}
      {...rest}
    >
      {children}
    </button>
  );
}
